<!--项目报名-->
<template>
  <div>
    <div>
      <top-item-com active="0" :ssid="ssid"></top-item-com>
    </div>

    <!-- 中间赛事信息 开始 -->
    <div class="titleDiv">
      <p
        style="margin-top: 10px;margin-bottom: 5px;font-size: 17px;font-weight: 600;"
      >
        {{ ssInfo.SSMC }}
      </p>
      <p style="margin-top: 5px;margin-bottom: 5px;">
        <van-tag
          :type="
            ssInfo.BSZT === '1'
              ? 'primary'
              : ssInfo.BSZT === '3'
              ? 'danger'
              : ssInfo.BSZT === '6'
              ? 'warning'
              : ssInfo.BSZT === '7'
              ? 'success'
              : ''
          "
        >
          {{
            ssInfo.BSZT === "-1"
              ? "报名未开始"
              : ssInfo.BSZT === "1"
              ? "报名中"
              : ssInfo.BSZT === "3"
              ? "报名结束"
              : ssInfo.BSZT === "6"
              ? "比赛中"
              : ssInfo.BSZT === "7"
              ? "比赛结束"
              : ""
          }}
        </van-tag>
      </p>

      <p
        style="margin-top: 15px;margin-bottom: 5px;font-size: 15px;"
        v-if="ssInfo.BMQSRQ !== undefined && ssInfo.BMQSRQ.length > 0"
      >
        <van-icon name="notes-o" />
        <span style="color:#B2B2B2">报名起始时间：</span>
        &nbsp;&nbsp;&nbsp;
        <span>
          {{ ssInfo.BMQSRQ }}
        </span>
      </p>

      <p
        style="margin-top: 15px;margin-bottom: 5px;font-size: 15px;"
        v-if="ssInfo.BMJZRQ !== undefined && ssInfo.BMJZRQ.length > 0"
      >
        <van-icon name="notes-o" />
        <span style="color:#B2B2B2">报名截止时间：</span>
        &nbsp;&nbsp;&nbsp;
        <span>
          {{ ssInfo.BMJZRQ }}
        </span>
      </p>

      <p
        style="margin-top: 15px;margin-bottom: 5px;font-size: 15px;"
        v-if="ssInfo.BSQSRQ !== undefined && ssInfo.BSQSRQ.length > 0"
      >
        <van-icon name="underway-o" />
        <span style="color:#B2B2B2">比赛日期：</span>
        &nbsp;&nbsp;&nbsp;
        <span>
          {{ ssInfo.BSQSRQ }} 至 {{ ssInfo.BSJZRQ }}
          <div
            style="color:red;margin-left: 145px;"
            v-if="
              ssid ===
                '372b74615172576674755068537965323637457141594a5a423438466d714f32'
            "
          >
            (根据人数暂定)
          </div>
        </span>
      </p>
      <p style="margin-top: 15px;margin-bottom: 5px;font-size: 15px;">
        <van-icon name="location-o" />
        <span style="color:#B2B2B2">比赛地址：</span>
        &nbsp;&nbsp;&nbsp;
        <span>{{ ssInfo.CGMC }}</span>
      </p>
      <!-- 报名阶段说明 开始 -->
      <div
        v-if="
          ssid ===
            '79316c74486b73572f6e463753376b686444774c4479565045504933436f2b79'
        "
        style="margin-top: 15px;margin-bottom: 15px;padding: 12px;background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);border-radius: 8px;color: #fff;"
      >
        <div
          style="font-size: 16px;font-weight: 600;margin-bottom: 10px;text-align: center;"
        >
          <van-icon name="calendar-o" style="font-size: 18px;" />
          总决赛报名安排
        </div>
        <div
          style="font-size: 14px;line-height: 1.8;background: rgba(255,255,255,0.15);padding: 10px;border-radius: 6px;"
        >
          <div style="margin-bottom: 8px;">
            <span style="font-weight: 600;">总人数：</span>
            <span style="font-size: 15px;font-weight: 700;">1500人</span>
            <span style="margin-left: 5px;opacity: 0.9;">（分三个阶段）</span>
          </div>
          <div
            style="border-top: 1px solid rgba(255,255,255,0.3);padding-top: 8px;"
          >
            <div style="margin-bottom: 6px;display: flex;align-items: center;">
              <span
                style="display: inline-block;width: 20px;height: 20px;background: #fff;color: #667eea;border-radius: 50%;text-align: center;line-height: 20px;font-weight: 700;font-size: 12px;margin-right: 8px;"
                >1</span
              >
              <span style="font-weight: 600;">第一阶段：</span>
              <span style="margin-left: 5px;">5月18日-5月30日</span>
              <span style="margin-left: auto;font-weight: 700;">500人</span>
            </div>
            <div style="margin-bottom: 6px;display: flex;align-items: center;">
              <span
                style="display: inline-block;width: 20px;height: 20px;background: #fff;color: #667eea;border-radius: 50%;text-align: center;line-height: 20px;font-weight: 700;font-size: 12px;margin-right: 8px;"
                >2</span
              >
              <span style="font-weight: 600;">第二阶段：</span>
              <span style="margin-left: 5px;">6月1日-6月20日</span>
              <span style="margin-left: auto;font-weight: 700;">500人</span>
            </div>
            <div style="display: flex;align-items: center;">
              <span
                style="display: inline-block;width: 20px;height: 20px;background: #fff;color: #667eea;border-radius: 50%;text-align: center;line-height: 20px;font-weight: 700;font-size: 12px;margin-right: 8px;"
                >3</span
              >
              <span style="font-weight: 600;">第三阶段：</span>
              <span style="margin-left: 5px;">6月22日-7月6日</span>
              <span style="margin-left: auto;font-weight: 700;">500人</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 报名阶段说明 结束 -->

      <div
        v-if="ISBMRCOUNT === '1'"
        style="margin-top: 15px;margin-bottom: 5px;font-size: 15px;position: relative;height: 78px;"
      >
        <div>
          <van-icon name="flag-o" />
          <span style="color:#B2B2B2">报名概况：</span>
        </div>
        <span>
          <van-circle
            v-model="ybmRcount"
            style="width: 80px;height:80px;position: absolute;right: 78px;top: 0px;"
            layer-color="#ebedf0"
            :rate="rateBl"
            :speed="100"
            :text="
              (ybmRCount - 0 > maxRCount ? maxRCount : ybmRCount) +
                '/' +
                (maxRCount - 0 > 10000 ? '无限制' : maxRCount + '人')
            "
          />
        </span>
      </div>
    </div>
    <!-- 中间赛事信息 结束 -->

    <div class="titleDiv" v-if="BMNR.length > 0">
      <p style="margin-top: 10px;margin-bottom: 5px;font-size: 15px;">
        报名要求：
      </p>
      <div v-html="BMNR"></div>
    </div>

    <div class="titleDiv">
      <p style="margin-top: 10px;margin-bottom: 5px;font-size: 15px;">
        规程说明：
      </p>
      <div v-html="SSGC"></div>
    </div>

    <!--个人报名弹出框 开始-->
    <van-action-sheet v-model="grReportShow" title="请选择项目">
      <div class="content">
        <change-xm
          :ssid="ssid"
          :resultXmList="resultXmList"
          :sslxList="sslxList"
          :utilPost="utilPost"
          :ISBMRCOUNT="ISBMRCOUNT"
          reportLx="GRDWBM"
          :isLd="'0'"
          bmLx="GR"
          dwid=""
          czlx="ADD"
          checkBmrsLx="ALLCHECK"
        ></change-xm>
        <div style="height:150px;width:15px;"></div>
      </div>
    </van-action-sheet>
    <!--个人报名弹出框 结束-->

    <!--底部导航栏  开始-->
    <van-tabbar v-if="isShowTabbar">
      <van-tabbar-item v-if="ssInfo.ISGRBM === '1' && ybmRCount < maxRCount"
        ><van-button round type="warning" @click="reportNavUrl('grbm')"
          >个人报名</van-button
        ></van-tabbar-item
      >
      <van-tabbar-item v-if="ssInfo.ISLDBM === '1' && ybmRCount < maxRCount">
        <van-button round type="primary" @click="reportNavUrl('ldbm')"
          >领队报名</van-button
        >
      </van-tabbar-item>
      <van-tabbar-item v-if="ybmRCount > maxRCount || ybmRCount === maxRCount">
        <van-button round type="primary">报名人数已满</van-button>
      </van-tabbar-item>
    </van-tabbar>
    <!--底部导航栏  结束-->
    <div style="height:150px;width:15px;"></div>
    <loading-com></loading-com>
  </div>
</template>

<script>
import ChangeXm from "../commonCom/ChangeXm.vue";
import LoadingCom from "../commonCom/LoadingCom.vue";
import TopItemCom from "../commonCom/TopItemCom.vue";
export default {
  components: { ChangeXm, LoadingCom, TopItemCom },
  name: "ReportXm",

  data() {
    return {
      ybmRcount: 0,
      BMNR: "",
      SSGC: "",
      grReportShow: false,
      utilPost: "",
      ssid: "",
      op: "wapGL",
      pageSet: {
        currentPage: 1, //当前页页码
        pageSize: 10, //每页默认显示的条数
        totalNums: 0 //数据总条数
      },
      search: {
        info: "",
        qslx: "",
        bszt: "",
        ssid: ""
      },
      ssInfo: {},
      resultXmList: [],
      sslxList: [],
      resultXmAllList: [],
      maxRCount: 0,
      ybmRCount: 0,
      ISBMRCOUNT: 0,
      rateBl: 0,
      isShowTabbar: false,
      routeValue: ""
    };
  },
  created() {
    this.utilPost = this.$util.handler;
    this.ssid = this.$route.query.ssid;
    this.search.ssid = this.ssid;
  },
  mounted() {
    var routeValue = localStorage.getItem("routeValue");
    this.routeValue = routeValue;
    // var openIdEn = localStorage.getItem("openIdEn");
    // if (openIdEn === undefined || openIdEn === null || openIdEn.length === 0) {
    //   this.utilPost.getOpenId(function(openId) {});
    // }
    this.mainData();
    // this.getXmData();
  },
  methods: {
    mainData() {
      this.search.ssid = this.ssid;
      var busData = {
        pageSet: this.pageSet,
        search: this.search
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: this.op, //反射名称
          methodName: "getSsxx" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        // alert(JSON.stringify(data));
        if (!data.isSuccess) {
          this.isShowTabbar = false;
          alert(data.msg);
          return;
        }
        this.isShowTabbar = true;
        this.ssInfo = data.content[0];
        this.BMNR = data.content[0].BMNR;
        this.SSGC = data.content[0].SSGC;
        this.maxRCount = data.lsData.maxRCount;
        this.ybmRCount = data.lsData.ybmRCount;
        this.ISBMRCOUNT = data.lsData.ISBMRCOUNT;
        this.rateBl =
          parseFloat(
            (parseFloat(this.ybmRCount) / parseFloat(this.maxRCount)).toFixed(2)
          ) * 100;
      });
    },
    getXmData() {
      //获取比赛项目
      var busData = { czlx: "ADD", isLoadDtInfo: "0", isLoadRyCount: "0" };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: this.op, //反射名称
          methodName: "getXmData" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        //alert(JSON.stringify(data));

        this.ISBMRCOUNT = data.content.ISBMRCOUNT;
        if (!data.isSuccess) {
          this.$notify({
            type: "danger",
            message: data.msg,
            duration: 3000
          });
          return;
        }
        this.resultXmAllList = data.content.resultXmList;
        this.sslxList = data.content.sslxList;

        //alert(JSON.stringify(this.sslxList));
      });
    },
    onTopClickLeft() {
      this.$router.go(-1);
    },
    onTopClickRight() {
      this.$router.go(-1);
    },
    reportNavUrl(type) {
      switch (type) {
        case "grbm": {
          if (this.ssInfo.BSZT !== "1") {
            alert("报名未开始或已结束");
            return;
          }
          this.$router.push({
            path: "/projectListIndex",
            query: {
              ssid: this.ssid,
              showXmlx: "DX",
              reportLx: "GRDWBM",
              isLd: "0",
              bmLx: "GR",
              dwid: "",
              czlx: "ADD",
              checkBmrsLx: "ALLCHECK"
            }
          });
          // this.resultXmList = [];
          // //个人报名 个人只能报单项赛  禁止报名团体赛
          // var resultXmAllList = this.resultXmAllList;
          // console.log(resultXmAllList);
          // for (var i = 0; i < resultXmAllList.length; i++) {
          //   var dataList = resultXmAllList[i].DATALIST;
          //   var dataListTemp = [];
          //   for (var j = 0; j < dataList.length; j++) {
          //     var SSLXTYPE = dataList[j].SSLX.substr(1, 2);
          //     if (SSLXTYPE !== "T") {
          //       dataListTemp.push(dataList[j]);
          //     }
          //   }
          //   if (dataListTemp.length > 0) {
          //     var tempItem = {
          //       XMJC: resultXmAllList[i].XMJC,
          //       ISBM: resultXmAllList[i].ISBM,
          //       DATALIST: dataListTemp
          //     };
          //     this.resultXmList.push(tempItem);
          //   }
          // }
          // this.grReportShow = true;
          break;
        }
        case "ldbm": {
          if (this.ssInfo.BSZT !== "1") {
            alert("报名未开始或已结束");
            return;
          }
          //领队报名
          this.$router.push({
            path: "/lingDuiReport",
            query: {
              ssid: this.ssid
            }
          });
          break;
        }
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.titleDiv {
  margin-top: 15px;
  margin-bottom: 15px;
  text-align: left;
  padding-left: 15px;
  background: #fff;
  padding-top: 5px;
  padding-bottom: 5px;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 5px;
}
.van-tag {
  font-size: 13px;
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 3px;
  padding-bottom: 3px;
}
.van-button {
  width: 130px;
  height: 35px;
}
/deep/ .van-circle__text {
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/ReportXm/ReportXm.vue